"use client";

import React, { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowDown } from "lucide-react";
export default function TheGlobalProforceNexus() {
  const [offsetY, setOffsetY] = useState(0);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const scrollPosition = window.scrollY;
        const sectionTop = sectionRef.current.offsetTop;
        const sectionHeight = sectionRef.current.offsetHeight;
        if (scrollPosition < sectionTop + sectionHeight) {
          setOffsetY(scrollPosition * 0.4);
        }
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="26570" id="strategic-vision-hero" ref={sectionRef} className="bg-background text-foreground relative min-h-screen w-full overflow-hidden flex flex-col items-center justify-center py-20 px-4">
      {}
      <div className="absolute inset-0 z-0 bg-[radial-gradient(circle_at_85%_40%,_hsl(200_80%_92%)_0%,_hsl(140_70%_92%)_30%,_transparent_70%)] pointer-events-none" />

      {}
      <div className="absolute inset-0 z-0 flex items-center justify-center opacity-5 pointer-events-none" style={{
      transform: `translateY(${offsetY}px)`
    }}>
        <div className="w-full h-full max-w-[1920px] max-h-[1080px]" />
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center text-center max-w-5xl mx-auto space-y-8">
        {}
        <div className="flex flex-col items-center animate-in fade-in zoom-in duration-1000 slide-in-from-bottom-10">
          <h1 className="font-sans text-5xl md:text-7xl lg:text-[80px] font-extrabold tracking-tighter leading-none text-foreground">
            BUILD THE ENTERPRISE THAT
          </h1>
          <span className="font-sans bg-gradient-to-r from-[hsl(200,80%,55%)] to-[hsl(140,70%,55%)] bg-clip-text text-transparent text-5xl md:text-7xl lg:text-[80px] font-extrabold tracking-tighter mt-2 md:mt-0 uppercase">
            MOVES FIRST
          </span>
        </div>

        {}
        <p className="text-muted-foreground text-lg md:text-[22px] max-w-2xl mx-auto leading-relaxed animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-300">
          We help organizations modernize data, deploy AI, and build intelligent 
          systems that drive real business outcomes through execution-driven transformation.
        </p>

        {}
        <div className="pt-8 animate-in fade-in slide-in-from-bottom-6 duration-1000 delay-500">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg px-8 py-6 rounded-sm shadow-md hover:shadow-lg transition-all duration-300">
            <Link to="/ContactPage">
              Start a Conversation
              <ArrowDown className="ml-2 h-5 w-5 animate-bounce" />
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent z-10 pointer-events-none" />
    </section>;
}